<div class="container-view-questionnaire">
  <div class="container-top">
    <header>
      <button class="buttonBack" mat-button (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>{{ 'common.back' | translate }}
      </button>
      <h1>{{ 'inclusion-index.self-assessment-title' | translate }}</h1>
      <p>{{ 'inclusion-index.self-assessment-subtitle' | translate }}</p>
    </header>
  </div>

  <div class="container-bottom" *ngIf="dimensions.length > 0  && dimensionForms.length > 0">
    <mat-stepper orientation="vertical" [linear]="true">
      <mat-step *ngFor="let formGroup of dimensionForms; let i = index" [stepControl]="formGroup">
        <form [formGroup]="formGroup">
          <ng-template matStepLabel>
            {{ 'common.dimension' | translate }}: {{ dimensions[i].dimensionCode | translate}}
          </ng-template>

          <div *ngFor="let question of dimensions[i].questions; let qIndex = index">
            <label>{{ question.questionCode | translate }}</label>
            <mat-radio-group
              [attr.aria-label]="'common.select-answer' | translate"
              formControlName="question{{ qIndex + 1 }}"
              class="radio-group"
            >
              <mat-radio-button *ngFor="let option of [1,2,3,4,5]" [value]="option">
                {{ option }}
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <div class="navigation-buttons">
            <button mat-button matStepperPrevious *ngIf="i !== 0">{{ 'common.back' | translate }}</button>
            <button mat-button matStepperNext *ngIf="i !== dimensionForms.length - 1">{{ 'common.next' | translate }}</button>
            <button mat-button color="primary" (click)="submit()" *ngIf="i === dimensionForms.length - 1">{{ 'common.submit' | translate }}</button>
          </div>
        </form>
      </mat-step>
    </mat-stepper>
  </div>
</div>
